module.exports = __webpack_public_path__ + "img/bronze-medal.8519adbb.svg";